type BrandMarkProps = {
  size?: number
  className?: string
}

/** The supplied open-book, pen-nib and sparkle mark. */
export function BrandMark({ size = 28, className }: BrandMarkProps) {
  const apiBase = import.meta.env.VITE_API_URL ?? window.location.origin
  const logoUrl = new URL('/api/branding/logo', apiBase).toString()

  return (
    <img
      className={className}
      width={size}
      height={size}
      src={logoUrl}
      alt="TeachCraftAI"
      onError={(event) => {
        event.currentTarget.onerror = null
        event.currentTarget.src = `${import.meta.env.BASE_URL}favicon.svg`
      }}
    />
  )
}
